var testi;
testi = $('.testimonials .owl-carousel').owlCarousel({
  loop:true,
  margin:0,
  responsiveClass:true,
  dots: true,
  dotsContainer: '.slider-bullet-img',
  nav:true,
  responsive:{
      0:{
          items:1,
      },
      1000:{
          items:1,
      }
  }
})

$('.slider-bullet-img').on('click', 'li', function(e) {
  testi.trigger('to.owl.carousel', [$(this).index(), 300]);
});